import { EMPTY, Observable } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';

interface TapResponseObserver<T, E> {
  readonly complete?: () => void;
  readonly error: (error: E) => void;
  readonly finalize?: () => void;
  readonly next: (value: T) => void;
}

export function tapResponse<T, E>(observer: TapResponseObserver<T, E>): (source$: Observable<T>) => Observable<T> {
  return (source) => source.pipe(
    tap({ next: observer.next, complete: observer.complete }),
    catchError((error: E) => {
      observer.error(error);

      return EMPTY;
    }),
    observer.finalize ? finalize(observer.finalize) : (source$) => source$,
  );
}
